import { Component, effect, inject } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AdminEventAnalyticsFiltersComponent } from '@pages/admin/admin-event-analytics/admin-event-analytics-filters/admin-event-analytics-filters.component';
import { AdminEventAnalyticsGroupsComponent } from '@pages/admin/admin-event-analytics/admin-event-analytics-groups/admin-event-analytics-groups.component';
import { AdminEventAnalyticsKpisComponent } from '@pages/admin/admin-event-analytics/admin-event-analytics-kpis/admin-event-analytics-kpis.component';
import { AdminEventAnalyticsOverviewComponent } from '@pages/admin/admin-event-analytics/admin-event-analytics-overview/admin-event-analytics-overview.component';
import { AdminEventAnalyticsUsersComponent } from '@pages/admin/admin-event-analytics/admin-event-analytics-users/admin-event-analytics-users.component';
import { BannerCardComponent } from '@shared/components/banner-card/banner-card.component';
import { IBreadcrumb } from '@shared/components/breadcrumb/breadcrumb.component';
import { ContentContainerComponent } from '@shared/components/content-container/content-container.component';
import { IEventAnalyticsScopeState } from './admin-event-analytics.interface';
import { AdminEventAnalyticsStore } from './admin-event-analytics.store';

@Component({
  imports: [
    AdminEventAnalyticsFiltersComponent,
    AdminEventAnalyticsGroupsComponent,
    AdminEventAnalyticsKpisComponent,
    AdminEventAnalyticsOverviewComponent,
    AdminEventAnalyticsUsersComponent,
    BannerCardComponent,
    ContentContainerComponent,
    MatTabsModule,
    TranslateModule,
  ],
  providers: [AdminEventAnalyticsStore],
  selector: 'app-admin-event-analytics',
  templateUrl: './admin-event-analytics.component.html',
})
export class AdminEventAnalyticsComponent {
  public readonly store = inject(AdminEventAnalyticsStore);

  private readonly translate = inject(TranslateService);

  public readonly breadcrumbs: IBreadcrumb[] = [
    {
      label: this.translate.instant('pages.admin.eventAnalytics.navigationTitle'),
      link: '/dashboard',
    },
  ];

  constructor() {
    this.store.fetchUserGroups();

    // Owned here (rather than in the individual tab components that display this data) so
    // switching between tabs never re-triggers a fetch (and its loading flicker) for data that's
    // already loaded and hasn't gone stale - only an actual scope change should do that.
    effect(() => {
      this.store.scope$();
      this.store.fetchKpis();
      this.store.fetchKpisPerUserGroup();
      this.store.fetchKpisPerUser();
    });
  }

  public onScopeChanged(scope: IEventAnalyticsScopeState): void {
    this.store.setScope(scope);
  }
}
